import { useNavigate } from 'react-router';

import { Button } from '@/components/ui/button';

const ResetPasswordConfirmation = () => {
  const navigate = useNavigate();

  return (
    <Button className="w-full" size="lg" onClick={() => navigate('/login')}>
      Sign in
    </Button>
  );
};

export default ResetPasswordConfirmation;
